<template>
  <b-col class="">
    <b-row v-if="items.length">
      <b-col cols="12">
        <headerPdf :title="$lang.years_of_service" />
      </b-col>
    </b-row>

    <b-row v-for="(item, i) in renderedItems" :key="i" class="my-2">
      <b-col cols="12">
        <div class="f-s-b-12 blockquote-footer my-2">
          <span class="f-s-b-12">
            {{
              `به مدت ${item.serviceHistory} - ${item.jobLevel} - ${item.serviceType} - ${$lang.to_date} ${item.toDate}`
            }}
          </span>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import headerPdf from "../headerPdf.vue";
import { pathOr } from "ramda";

export default {
  name: "JobInfo",
  components: {
    headerPdf,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    renderedItems() {
      return this.items.map((item) => {
        return {
          serviceHistory: pathOr("", ["service_history"], item),
          jobLevel: pathOr("", ["person_company_job_level", "caption"], item),
          serviceType: pathOr("", ["service_type", "caption"], item),
          toDate: pathOr("", ["to_date", "jalali"], item),
        };
      });
    },
  },
  methods: { pathOr },
};
</script>

<style lang="scss" scoped>
.information-pro {
  font-size: 14px;
  font-weight: 500;
  color: #282c52;
}
</style>
